import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
dayjs.extend(utc)
dayjs.extend(timezone)

export enum DatePickerMode {
	DATE = 'single',
	RANGE = 'range',
	TIME = 'time',
	DATETIME = 'datetime',
	MULTIPLE_DATES = 'multiple'
}

export type UnixDateRange = [number, number]

export function convertUnixToUtc(date: number, originalTimezone?: string): dayjs.Dayjs {
	let originalDate = dayjs.unix(date)

	if (originalTimezone) {
		originalDate = originalDate.tz(originalTimezone)
	}

	const year = originalDate.year()
	const month = originalDate.month()
	const day = originalDate.date()

	return dayjs.utc().year(year).month(month).date(day)
}

export function convertUnixToLocale(date: number, originalTimezone: string = 'utc'): dayjs.Dayjs {
	let originalDate = dayjs.unix(date)

	if (originalTimezone) {
		originalDate = originalDate.tz(originalTimezone)
	}

	const year = originalDate.year()
	const month = originalDate.month()
	const day = originalDate.date()

	return dayjs().year(year).month(month).date(day)
}

export function convertUnixToUtcStart(date: number, timezone?: string): dayjs.Dayjs {
	return convertUnixToUtc(date, timezone).startOf('day')
}

export function convertUnixToUtcEnd(date: number, timezone?: string): dayjs.Dayjs {
	return convertUnixToUtc(date, timezone).endOf('day')
}
